module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 309
// module chunks = 0